import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/key-managements`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getByEntities({commit}, payload: {
    keyId?: number,
    keyGroupId?: number,
    userId?: number,
    userGroupId?: number,
  }) {
    return axiosInstance.get(`${baseUrl}`, {params: payload})
      .then((data) => data.data);
  },
  deleteById({commit}, payload: { keyManagementId: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.keyManagementId}`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
